.image-overlay-wrapper {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.image-overlay-wrapper-dark {
  background-color: var(--rds-background-overlay-heavy);
}

.image-overlay-wrapper-gradient {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0.7) 100%);
}

.image-overlay-wrapper-center {
  align-items: center;
  justify-content: center;
  text-align: center;
}

.image-overlay-title {
  opacity: 0;
}

@media (hover: hover) {
  .image-overlay-wrapper-show-on-hover > [class] {
    opacity: 0;
    transition: opacity 250ms;
  }

  .image-overlay-wrapper-show-on-hover:focus-within > *:first-child,
  .image-overlay-wrapper-show-on-hover:hover > *:first-child {
    opacity: 1;
  }

  .image-overlay-wrapper-dark {
    transition: background-color 250ms;
    background-color: var(--rds-background-overlay-medium);
  }

  .image-overlay-wrapper-dark:hover {
    background-color: var(--rds-background-overlay-heavy);
  }
}

@media (pointer: coarse) {
  .image-overlay-title {
    opacity: 1;
  }
}

.image-overlay-wrapper:hover .image-overlay-title,
:global(.tvshow-episodes__episode:hover) .image-overlay-title,
:global(.swimlane-standard-item:hover) .image-overlay-title {
  opacity: 1;
  display: block;
}
